<template>
  <div v-bind:class="{ 'd-none': rutaDelDocumento != null ? false : true }">
    <div
      class="modal fade bd-example-modal-lg fondo-modal"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" style="height: 68em !important;">
        <div class="modal-content" style="height: 68em !important;">
          <!-- <object  :data="rutaDelDocumento" type="application/pdf" style="height: 68em !important;"   :key="rutaDelDocumento"></object> -->
          <PDFV2
            ref="pdf"
            v-if="rutaDelDocumento != null"
            :url="rutaDelDocumento"
            :porPaginas="true"
            :conDescarga="true"
            :conImprimir="true"
            :conCopiarlink="true"
            :key="rutaDelDocumento"
          ></PDFV2>
          <button class="btn btn-danger cerrarElVisor" @click="CierraElVisor()">
            <i class="fas fa-times"></i>&nbsp;&nbsp;&nbsp;&nbsp;Cerrar el
            documento
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PDFV2 from "@/components/Comunes/VisorPDFV2.vue";
import comun from "@/../static/js/comun";
import api from "@/../static/js/api";
import axios from "axios";

export default {
  components: {
    PDFV2
  },
  computed: {
    rutaDelDocumento() {
      $(".bd-example-modal-lg").modal("show");
      //console.log("visor de documentos:::",this.$store.getters.Get_PaginaOficial_RutaParaElVisor);
      return this.$store.getters.Get_PaginaOficial_RutaParaElVisor;
    }
  },
  methods: {
    CierraElVisor: function() {
      $(".bd-example-modal-lg").modal("hide");
      this.$store.dispatch("A_PaginaOficial_EstableceLaRutaParaElVisor", null);
    }
  }
};
</script>

<style scoped>
.fondo-modal {
  width: "100%" !important;
  background-color: dimgrey;
}

.cerrarElVisor {
  bottom: 0 ;   
  position: sticky; 
  font-size: 2.5vh;
  width: 100%;
  height: 2.5em;
  padding-bottom: 2em; 

  /* position:sticky !important;
  width:100%;
  height:10em !important;
  bottom:40px;
  right:40px;
  background-color:#C62009;
  color:#FFF;
  border-radius:30px;
  text-align:center;
  font-size:30px;
  z-index:100; */


}

@media screen and (min-width: 992px) {
  .modal-lg {
    max-width: 1200px;
  }
}

@media screen and (min-width: 576px) {
  .modal-dialog {
    max-width: 1300px;
    margin: 1.75rem auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/Comun/VisorDeDocumentos.vue